import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-forbidden-sign",
  "use": "svgIcon-forbidden-sign-usage",
  "viewBox": "0 0 84 84",
  "content": "<symbol viewBox=\"0 0 84 84\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-forbidden-sign\"><path d=\"m42 0c-23.196 0-42 18.807-42 42 0 23.197 18.804 42 42 42 23.195 0 42-18.803 42-42 0-23.193-18.805-42-42-42zm25.248 36.889.002 10.223h-50.5v-10.221z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol